import React from 'react';

const style: { [maskType: string]: string } = { 'mask-type': 'alpha' };

const PigiBank = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <mask
      id="mask0_24_2149"
      style={style}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_24_2149)">
      <path
        d="M10.6666 7.33337C10.8555 7.33337 11.0138 7.26949 11.1416 7.14171C11.2694 7.01393 11.3333 6.8556 11.3333 6.66671C11.3333 6.47782 11.2694 6.31949 11.1416 6.19171C11.0138 6.06393 10.8555 6.00004 10.6666 6.00004C10.4777 6.00004 10.3194 6.06393 10.1916 6.19171C10.0638 6.31949 9.99992 6.47782 9.99992 6.66671C9.99992 6.8556 10.0638 7.01393 10.1916 7.14171C10.3194 7.26949 10.4777 7.33337 10.6666 7.33337ZM5.33325 6.00004H8.66658V4.66671H5.33325V6.00004ZM2.99992 14C2.62214 12.7334 2.24992 11.4695 1.88325 10.2084C1.51659 8.94726 1.33325 7.6556 1.33325 6.33337C1.33325 5.31115 1.68881 4.44449 2.39992 3.73337C3.11103 3.02226 3.9777 2.66671 4.99992 2.66671H8.33325C8.65547 2.24449 9.04714 1.91671 9.50825 1.68337C9.96936 1.45004 10.4666 1.33337 10.9999 1.33337C11.2777 1.33337 11.5138 1.4306 11.7083 1.62504C11.9027 1.81949 11.9999 2.0556 11.9999 2.33337C11.9999 2.40004 11.9916 2.46671 11.9749 2.53337C11.9583 2.60004 11.9388 2.66115 11.9166 2.71671C11.8721 2.83893 11.8305 2.96393 11.7916 3.09171C11.7527 3.21949 11.7221 3.35004 11.6999 3.48337L13.2166 5.00004H14.6666V9.65004L12.7833 10.2667L11.6666 14H7.99992V12.6667H6.66658V14H2.99992ZM3.99992 12.6667H5.33325V11.3334H9.33325V12.6667H10.6666L11.6999 9.23337L13.3333 8.68337V6.33337H12.6666L10.3333 4.00004C10.3333 3.77782 10.3471 3.56393 10.3749 3.35837C10.4027 3.15282 10.4444 2.94449 10.4999 2.73337C10.1777 2.82226 9.89436 2.97504 9.64992 3.19171C9.40547 3.40837 9.2277 3.67782 9.11658 4.00004H4.99992C4.35547 4.00004 3.80547 4.22782 3.34992 4.68337C2.89436 5.13893 2.66659 5.68893 2.66659 6.33337C2.66659 7.42226 2.81659 8.48615 3.11659 9.52504C3.41659 10.5639 3.71103 11.6112 3.99992 12.6667Z"
        fill="#00A331"
      />
    </g>
  </svg>
);

export default PigiBank;
